import { sleep } from './sleep';

/**
 * スタンプ落下アニメ composable。
 *
 * 仕様: _docs/event/130-spec.md §8 スタンプカード フロントUI (anarchy2024 移植)
 *
 * Phase 構成（合計 ~850ms）:
 *   1. スタンプ落下 (scale 6→1, 50 × 5ms = 250ms)
 *   2. 着地 (SE発火、 現状は console.log)
 *   3. 赤光残光 (text-shadow 0→10px, 10 × 30ms = 300ms)
 *   4. 赤光残光 (text-shadow 10→0px, 10 × 30ms = 300ms)
 *
 * @param {import('vue').Ref<string>} activeStyleRef アニメ中の style 文字列を入れる ref
 * @returns {() => Promise<void>} アニメ実行関数
 */
export function useStampAnimation(activeStyleRef) {
    return async function animate() {
        // Phase 1: scale down
        let scale = 6;
        const FRAMES = 50;
        for (let t = 0; t < FRAMES; t++) {
            scale -= 5 / FRAMES;
            activeStyleRef.value = `transform: scale(${scale});`;
            await sleep(5);
        }

        // Phase 2: 着地 SE (placeholder)
        // TODO: useSe('stamp') 相当の音声再生を組み込む
        if (window.console) console.debug('[stamp] landed');

        // Phase 3: 赤光残光 (拡大)
        for (let s = 0; s < 10; s++) {
            activeStyleRef.value = `text-shadow: 0 0 ${s}px #f00;`;
            await sleep(30);
        }

        // Phase 4: 赤光残光 (縮小)
        for (let s = 10; s > 0; s--) {
            activeStyleRef.value = `text-shadow: 0 0 ${s}px #f00;`;
            await sleep(30);
        }

        activeStyleRef.value = '';
    };
}
